// GLOSS testIds — one source of truth for all data-testid values
export const LOGIN_PAGE = {
  root: "login-page",
  phoneInput: "login-phone-input",
  continueBtn: "login-continue-btn",
  otpInput: "login-otp-input",
  verifyBtn: "login-verify-btn",
  backBtn: "login-back-btn",
};

export const PERSONA = {
  root: "persona-selector",
  card: (key) => `persona-card-${key}`,
  enterBtn: (key) => `persona-enter-${key}`,
  salonChip: "persona-salon-chip",
  logoutBtn: "persona-logout-btn",
};

export const RECEPTIONIST = {
  root: "receptionist-view",
  kpiInQueue: "kpi-in-queue",
  kpiCheckedIn: "kpi-checked-in",
  kpiInService: "kpi-in-service",
  kpiCompleted: "kpi-completed",
  addClientBtn: "add-client-btn",
  checkInNextBtn: "check-in-next-btn",
  broadcastBtn: "broadcast-delay-btn",
  emergencyBtn: "emergency-walk-in-btn",
  waitlistBtn: "waitlist-auto-promote-btn",
  appointmentRow: (id) => `appointment-row-${id}`,
  statusSelect: (id) => `status-select-${id}`,
  addClientModal: "add-client-modal",
  emergencyModal: "emergency-modal",
  broadcastModal: "broadcast-modal",
};

export const STYLIST = {
  root: "stylist-view",
  queueCard: (id) => `stylist-queue-${id}`,
  beginServiceBtn: "stylist-begin-service",
  applySendBtn: "stylist-apply-send-billing",
  saveNotesBtn: "stylist-save-notes",
  formulaInput: "stylist-formula-input",
  tabService: "stylist-tab-service",
  tabHistory: "stylist-tab-history",
  tabProfile: "stylist-tab-profile",
};

export const BILLING = {
  root: "billing-view",
  pendingCard: (id) => `billing-pending-${id}`,
  amountDue: "billing-amount-due",
  payCashBtn: "pay-method-cash",
  payUpiBtn: "pay-method-upi",
  payCardBtn: "pay-method-card",
  confirmBtn: "billing-confirm-btn",
  splitToggle: "billing-split-toggle",
  discountInput: "billing-discount-input",
  tipInput: "billing-tip-input",
  whatsappReceiptBtn: "billing-whatsapp-receipt",
  giftCardInput: "billing-gift-card-input",
  applyLoyaltyToggle: "billing-loyalty-toggle",
  reconcileBtn: "billing-reconcile-btn",
  reconcileModal: "reconcile-modal",
  reconcileActualInput: "reconcile-actual-input",
  reconcileExportBtn: "reconcile-export-btn",
  couponInput: "billing-coupon-input",
  couponApplyBtn: "billing-coupon-apply-btn",
  couponClearBtn: "billing-coupon-clear-btn",
  couponError: "billing-coupon-error",
  couponApplied: "billing-coupon-applied",
  invoiceDownloadBtn: "billing-invoice-download-btn",
  refundLink: (id) => `billing-refund-link-${id}`,
  refundModal: "billing-refund-modal",
  refundAmountInput: "billing-refund-amount-input",
  refundReasonInput: "billing-refund-reason-input",
  refundConfirmBtn: "billing-refund-confirm-btn",
  refundMethod: (m) => `billing-refund-method-${m}`,
};

export const OWNER = {
  root: "owner-dashboard",
  kpiRevenue: "owner-kpi-revenue",
  kpiClients: "owner-kpi-clients",
  kpiCompleted: "owner-kpi-completed",
  kpiAvgTime: "owner-kpi-avg-time",
  copilotInput: "owner-copilot-input",
  copilotSubmit: "owner-copilot-submit",
  branchSelector: "owner-branch-selector",
  commissionExportBtn: "owner-commission-export-btn",
  commissionExportModal: "owner-commission-export-modal",
  commissionDownloadBtn: "owner-commission-download-btn",
  branchCompareCard: (id) => `owner-branch-card-${id}`,
  birthdayVoucherBtn: (id) => `owner-birthday-voucher-${id}`,
};

export const STYLIST_EXTRA = {
  birthdayVoucherBtn: "stylist-birthday-voucher-btn",
  myCommissionBox: "stylist-my-commission-box",
};

export const RECEPTIONIST_EXTRA = {
  birthdayBadge: (id) => `receptionist-birthday-${id}`,
  conflictWarning: "add-client-conflict-warning",
  emergencyOverrideBadge: "emergency-override-badge",
  cancelLink: (id) => `appt-cancel-link-${id}`,
  rescheduleLink: (id) => `appt-reschedule-link-${id}`,
  cancelModal: "appt-cancel-modal",
  cancelReasonInput: "appt-cancel-reason-input",
  cancelConfirmBtn: "appt-cancel-confirm-btn",
  rescheduleModal: "appt-reschedule-modal",
  rescheduleDateBtn: (d) => `appt-reschedule-date-${d}`,
  rescheduleSlotBtn: (t) => `appt-reschedule-slot-${t}`,
  rescheduleStylistSelect: "appt-reschedule-stylist-select",
  rescheduleConfirmBtn: "appt-reschedule-confirm-btn",
  // P1.5 — extended intake fields
  moreToggle: "add-client-more-toggle",
  moreSection: "add-client-more-section",
  dobInput: "add-client-dob-input",
  anniversaryInput: "add-client-anniversary-input",
  emailInput: "add-client-email-input",
  occupationInput: "add-client-occupation-input",
  locationInput: "add-client-location-input",
  referralInput: "add-client-referral-input",
  smartRibbon: "smart-intake-ribbon",
  smartDob: "smart-intake-dob",
  smartAnniversary: "smart-intake-anniversary",
  smartVip: "smart-intake-vip",
  smartBranch: "smart-intake-branch",
  smartAllergy: "smart-intake-allergy",
};

export const COUPONS = {
  root: "coupons-view",
  toggle: "coupons-toggle",
  createBtn: "coupons-create-btn",
  createModal: "coupons-create-modal",
  codeInput: "coupons-code-input",
  typeToggle: (t) => `coupons-type-${t}`,
  valueInput: "coupons-value-input",
  minBillInput: "coupons-min-bill-input",
  maxDiscountInput: "coupons-max-discount-input",
  validFromInput: "coupons-valid-from-input",
  validUntilInput: "coupons-valid-until-input",
  usageLimitInput: "coupons-usage-limit-input",
  unlimitedToggle: "coupons-unlimited-toggle",
  branchSelect: "coupons-branch-select",
  createSubmitBtn: "coupons-create-submit-btn",
  row: (id) => `coupons-row-${id}`,
  deactivateBtn: (id) => `coupons-deactivate-${id}`,
};

export const OWNER_EXTRA = {
  refundsTile: "owner-refunds-tile",
  sendRemindersBtn: "owner-send-reminders-btn",
  noshowRateTile: "owner-noshow-rate-tile",
  satisfactionTile: "owner-satisfaction-tile",
  expiringPanel: "owner-expiring-panel",
  expiringItem: (id) => `owner-expiring-item-${id}`,
  anniversariesPanel: "owner-anniversaries-panel",
  anniversarySendBtn: (id) => `owner-anniversary-send-${id}`,
  winbackSendNowBtn: "owner-winback-send-now-btn",
};

export const PACKAGES = {
  root: "packages-view",
  toggle: "packages-toggle",
  createBtn: "packages-create-btn",
  createModal: "packages-create-modal",
  nameInput: "packages-name-input",
  descInput: "packages-desc-input",
  categoryToggle: (c) => `packages-category-${c}`,
  serviceSelect: "packages-service-select",
  priceInput: "packages-price-input",
  validDaysInput: "packages-valid-days-input",
  submitBtn: "packages-submit-btn",
  row: (id) => `packages-row-${id}`,
  deactivateBtn: (id) => `packages-deactivate-${id}`,
};

export const VENDORS = {
  root: "vendors-view",
  toggle: "vendors-toggle",
  createBtn: "vendors-create-btn",
  createModal: "vendors-create-modal",
  nameInput: "vendors-name-input",
  phoneInput: "vendors-phone-input",
  contactInput: "vendors-contact-input",
  termsSelect: "vendors-terms-select",
  submitBtn: "vendors-submit-btn",
  row: (id) => `vendors-row-${id}`,
  sendPoBtn: (id) => `vendors-send-po-${id}`,
  poModal: "vendors-po-modal",
  poItemInput: (i) => `vendors-po-item-${i}`,
  poQtyInput: (i) => `vendors-po-qty-${i}`,
  poPriceInput: (i) => `vendors-po-price-${i}`,
  poAddItemBtn: "vendors-po-add-item-btn",
  poSendBtn: "vendors-po-send-btn",
};

export const CONSENT = {
  modal: "consent-modal",
  allergiesCheckbox: "consent-allergies",
  historyCheckbox: "consent-history",
  cancellationCheckbox: "consent-cancellation",
  signaturePad: "consent-signature-pad",
  clearSignatureBtn: "consent-clear-signature",
  confirmBtn: "consent-confirm-btn",
  chipSigned: (id) => `consent-chip-signed-${id}`,
  chipPending: (id) => `consent-chip-pending-${id}`,
};

export const FEEDBACK = {
  history: "feedback-history",
  star: (i) => `feedback-star-${i}`,
};

export const SETTINGS_MODAL_GST = {
  gstinInput: "settings-gstin-input",
  gstRateInput: "settings-gst-rate-input",
  invoicePrefixInput: "settings-invoice-prefix-input",
  salonAddressInput: "settings-salon-address-input",
};

export const FLOORMAP = {
  root: "floormap-view",
  tile: (id) => `floor-tile-${id}`,
};

export const SHIFTS = {
  root: "shifts-view",
  publishBtn: "shifts-publish-week",
  cell: (staffId, date) => `shift-cell-${staffId}-${date}`,
};

export const DISPLAY = {
  root: "waiting-display",
  nowServingToken: "display-now-serving-token",
};

export const SETTINGS_MODAL = {
  root: "settings-modal",
  saveBtn: "settings-save-btn",
  salonNameInput: "settings-salon-name",
  branchNameInput: "settings-branch-name",
};
